var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10659 5.55395L12 11.7793L20.8934 5.55395C20.7281 5.22692 20.388 5 20 5H4.00002C3.61205 5 3.27197 5.22692 3.10659 5.55395ZM21 7.92066L12.5735 13.8192C12.2292 14.0603 11.7709 14.0603 11.4266 13.8192L3.00002 7.92066V18C3.00002 18.5477 3.4523 19 4.00002 19H20C20.5477 19 21 18.5477 21 18V7.92066ZM1.00002 6C1.00002 4.34772 2.34773 3 4.00002 3H20C21.6523 3 23 4.34771 23 6V18C23 19.6523 21.6523 21 20 21H4.00002C2.34773 21 1.00002 19.6523 1.00002 18V6Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail.63e3baa9.svg";
export { ForwardRef as ReactComponent };